export enum AppNotificationType {
  SUCCESS = "success",
  INFO = "info",
  ERROR = "error",
  WARNING = "warning"
}
